<template>
  <div class="finalizacao-alert">
    <div class="content-modal">
      <h2>{{title}}</h2>
      <div class="progress">
        <div
          class="progress-step"
          :class="{'ativo': currentstep >= 1}"
          @click="currentstep=1">
          1
        </div>
        <div
          class="progress-step"
          :class="{'ativo': currentstep >= 2}">
          2
        </div>
      </div>

      <template v-if="currentstep==1">
        <p v-for="linha in text" :key="linha.index">{{linha}}</p>
      </template>

      <template v-else-if="currentstep==2">
        <div class="container-obs">
          <label>Observação: </label>
          <div class="text-box">
            <textarea class="observacao" type="text" v-model="observacao" maxlength="255" rows="5"/>
            <legend>{{255 - observacao.length}}</legend>
          </div>
        </div>
        <p class="text-valor-total">Valor Total: {{valorTotal.toFixed(2)}}</p>
      </template>

      <div class="btn-finalizacao">
        <button class="btn-cancelar-pedido"
          @click="$emit('update:modelValue', false);
          $emit('close')">
          Cancelar
        </button>
        <button v-if="currentstep === 1" @click="currentstep++">
          Próximo
        </button>
        <button v-else @click="$emit('update:modelValue', true);
          $emit('update:obs', observacao);
          $emit('close')">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalFinalizacao',
  emits: [
    'update:modelValue',
    'update:obs',
    'close'
  ],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    obs: String,
    title: String,
    text: Array,
    valorTotal: Number
  },
  data () {
    return {
      currentstep: 1,
      observacao: ''
    }
  }

}
</script>

<style lang="scss">
  .finalizacao-alert {
    position: fixed;
    z-index: 999;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(53, 53, 53, 0.5);
    display: grid;
    transition: opacity 0.3s ease;
    overflow-y: initial !important;
    align-content: center;
  }

  .finalizacao-alert:target {
    opacity: 1;
    pointer-events: auto;
  }

  .content-modal {
    width: 70%;
    position: relative;
    background-color: #ffffff;
    transition: opacity 3s ease !important;
    align-content: center;
    left: 15%;

    .container-obs {
      display: flex;
      flex-direction: column;
      align-items: center;
      .text-box {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        width: 80%;
        .observacao {
          border:solid 1px #C2171A;
          width: 90%;
        }

      }
    }

    .text-valor-total {
      color: #C2171A;
      font-weight: 600;
      font-size: 1.2rem;
    }

    .btn-finalizacao {
      display: inline-block;
    }

    .btn-cancelar-pedido {
      background-color: #ffffff00;
      color: #C2171A;
    }

    button {
      width: auto;
    }

    .progress {
      display: flex;
      flex-direction: row;
      position:relative;
      border-radius: 50%;
      font-weight: bold;
      margin: 5px;
    }

    .progress-step {
      width: 50px;
      margin: 1px;
      color: #555;
      background-color: rgb(231, 231, 231);
    }

    .ativo  {
      width: 50px;
      margin: 1px;
      color: #DF5C2E;
      background-color: rgb(255, 252, 57);
    }

  }
</style>
